import type {ShopProduct} from '../components/ShopCatalogue';

export const choiceModels=(product:ShopProduct)=>Array.from(new Set([...(product.compatibleVehicles||[]).filter(m=>m!=='any'),...(product.compatibleVehicles?.includes('any')?['other-evs']:[])]));

/** One priced variant per compatible model needs no second model selector. */
export function modelOnlyVariants(product:ShopProduct){
 const models=choiceModels(product),variants=(product.installationOptions||[]).filter(o=>o.kind==='variant'||o.kind==='tint');
 return !!product.requireModelSelection && models.length>0 && variants.length===models.length
  && variants.every(o=>o.kind==='variant'&&!!o.model&&models.includes(o.model))
  && new Set(variants.map(o=>o.model)).size===models.length;
}
